/**
 * assets/quote-modal.js
 *
 * - NO intercepta el submit (para que Shopify ENVÍE el email real)
 * - Reabre el modal automáticamente si hay success/error dentro del form
 * - No cierra el modal (solo X o click fuera, como el theme)
 */
(function () {
  function openModal(modal) {
    // Dawn-like modal-dialog suele tener .show()
    if (modal && typeof modal.show === "function") {
      modal.show();
      return;
    }

    // fallback: si el theme usa attribute open
    if (modal) modal.setAttribute("open", "");
  }

  function focusStatus(statusEl) {
    try {
      statusEl.scrollIntoView({ behavior: "smooth", block: "start" });
      statusEl.setAttribute("tabindex", "-1");
      statusEl.focus({ preventScroll: true });
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Si Shopify ha renderizado un success/error, lo marcamos con data-quote-status
    const statusEl = document.querySelector("[data-quote-status]");
    if (!statusEl) return;

    const modal = statusEl.closest("modal-dialog");
    if (!modal) return;

    // Reabrimos el modal para que se vean los mensajes
    openModal(modal);

    // Aseguramos que el usuario vea el mensaje
    focusStatus(statusEl);
  });
})();
